export function oxgFnByName(fnName, arg = null) {
  if(fnName && typeof fnName == 'string') {
    if (fnName && typeof window[fnName] === "function") {
      if(!arg) { 
        window[fnName]() 
      } else {
        window[fnName](arg)
      }
    }
  }
}